'use client'

import { createContext, useContext, type ReactNode } from 'react'
import type { User } from 'firebase/auth'

export type AuthContextValue = {
	user: User | null
	error: string | null
	/** Hasta resolverse el primer `onAuthStateChanged` o durante `login` / `logout`. */
	loading: boolean
	/** `true` tras el primer `onAuthStateChanged` (equivalente a `initAuth` resuelto en certisep Vue). */
	sessionReady: boolean
	authToken: string | undefined
	login: (email: string, password: string) => Promise<{ email: string | null; uid: string }>
	logout: () => Promise<void>
	getAuthToken: () => Promise<string | undefined>
}

const AuthStateContext = createContext<AuthContextValue | null>(null)

export function useAuth(): AuthContextValue {
	const ctx = useContext(AuthStateContext)
	if (ctx == null) {
		throw new Error('useAuth debe usarse dentro de AuthProvider (layout raíz).')
	}
	return ctx
}

export function AuthStateContextProvider({ value, children }: Readonly<{ value: AuthContextValue; children: ReactNode }>) {
	return <AuthStateContext.Provider value={value}>{children}</AuthStateContext.Provider>
}
